// product list
export const TERMS_AND_CONDITIONS_REQUEST = 'TERMS_AND_CONDITIONS_REQUEST';
export const TERMS_AND_CONDITIONS_SUCCESS = 'TERMS_AND_CONDITIONS_SUCCESS';
export const TERMS_AND_CONDITIONS_ERROR = 'TERMS_AND_CONDITIONS_ERROR'; 
